<template>
    <div :class="{'p-4' : !noPadding}">

        <!-- Close -->
        <div class="float-end ms-3">
            <a href="#" class="text-muted text-decoration-none text-md" @click.prevent="$emit('closePanel')"><span aria-hidden="true">×</span></a>
        </div>

        <!-- Actions -->
        <div class="float-end mb-2">
            <slot name="actions"></slot>
        </div>

        <!-- Title -->
        <h4 v-if="title">{{ title }}</h4>

        <!-- Loading -->
        <div v-if="loading">
            <Spinner /> {{ $t('panel.loading') }}…
        </div>

        <!-- Content -->
        <slot v-else></slot>

    </div>
</template>

<script>
    import Spinner from '../Loaders/Spinner'

    export default {
        name: 'Panel',
        props: {
            title: String,
            loading: Boolean,
            noPadding: Boolean,
        },
        components: {
            Spinner
        }
    }
</script>
